export const commandType = "SCHEDULE_MOVE_XYZ";
export const label = "Move to xyz";
export const isAdminOnly = true;
export const isAdvanced = true;
export const organizations = [];
